import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('pulling_from_cin_core'),
    externalSubmitterDescription: defineMessage('templatename_in_the_dra__also_be_used_learnmore'),
};
